/** Everything that points to an external system lives here. */

const stripTrailingSlash = (url: string) => url.replace(/\/+$/, '');

/** WordPress instance that serves news, static pages and the JSON config posts. */
export const WORDPRESS_URL = stripTrailingSlash(process.env.REACT_APP_WORDPRESS_URL || 'https://wordpress.vch-online.at');
export const WP_API_URL = `${WORDPRESS_URL}/wp-json/wp/v2`;

/** volleynet XML service for the league tables. */
export const VOLLEYNET_TABLE_URL = 'https://dev.volleynet.at/volleynet/service/xml2.php';

/** WordPress category ids. */
export const CATEGORY = {
    config: 11,      // "Data": JSON config posts (appointments, clubs, tables, …)
    hidden: 13,      // "Hidden": never shown as news
    newsRoot: 12,    // "Visible": parent of all news categories
    important: 10,   // "Wichtig": shown in the slider on the home page
    herren1: 4,
    herren2: 5,
    damen1: 6,
    damen2: 7,
    jugend: 8,
    beach: 9,
} as const;

/** Matches the own teams in volleynet tables and in the appointments. */
export const OWN_CLUB_NAME = 'Hausmannstätten';
export const OWN_CLUB_LOGO_URL = `${WORDPRESS_URL}/wp-content/uploads/2023/09/VC-Hausmannstaetten_gross.png`;

/** Cached API responses are shown immediately and refreshed in the background once older than this. */
export const CACHE_TTL_MS = 5 * 60 * 1000;
